import React, {Component} from "react";
import {connect} from "react-redux";
import applogic from "../applogic.js";

class VideoPlayer extends Component {

    componentDidMount() {
        applogic.handleVideoPlayerMounted(this.dom, this.videoTag);
    }

    componentDidUpdate() {
        applogic.handleVideoPlayerMounted(this.dom, this.videoTag);
    }

    componentWillUnmount() {
        applogic.handleVideoPlayerUnmounted();
    }

    render() {
        let currentVideo = this.props.currentVideo;
        let src = currentVideo && currentVideo.src;
        let thumbnail = applogic.getThumbnailUrlOrPlaceholder(currentVideo);
        return (
            <div className="video-player" ref={dom => {
                this.dom = dom;
            }}>
                <video poster={thumbnail} ref={v => {
                    this.videoTag = v;
                }} data-setup="{}">
                    {src && <source src={src} type={src.includes('.m3u8') ? 'application/x-mpegurl' : 'video/mp4'}/>}
                    <p>Video loading...</p>
                </video>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        currentVideo: state.currentVideo,
    };
};
export default connect(mapStateToProps)(VideoPlayer);


// WEBPACK FOOTER //
// ./src/componentsBody/VideoPlayer.js